import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Hamburger from '../buttons/Hamburger';

function LineDetection() {
  const location = useLocation();
  const navigate = useNavigate();
  const [receivedState, setReceivedState] = useState(null);
  const [isRunning, setIsRunning] = useState(false);
  const [result, setResult] = useState(null);
  const { state } = useLocation();
  const params = useParams();
  const effectiveUserId = state?.userId ?? (params?.userId ? parseInt(params.userId, 10) : null);
  const [resultImage, setResultImage] = useState(null);

  // ルート遷移時に渡された state を受け取る
  useEffect(() => {
    if (location && location.state) {
      setReceivedState(location.state);
      // ここで自動的に解析を開始したければ handleStart を呼ぶ
      // handleStart();
    }
  }, [location]);

  // dataURL -> Blob 変換のユーティリティ
  const dataURLToBlob = (dataURL) => {
    const arr = dataURL.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };

  const handleStart = async () => {
    if (!receivedState || !receivedState.imageUrl) {
      alert('画像が見つかりません');
      return;
    }
    setIsRunning(true);
    try {
      const blob = dataURLToBlob(receivedState.imageUrl);
      const formData = new FormData();
      formData.append('file', blob, 'selected_image.png');
      formData.append('ellipses', JSON.stringify(receivedState.ellipses || {}));
      if (effectiveUserId !== null && effectiveUserId !== undefined) {
        formData.append('userId', String(effectiveUserId));
      }

      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      const response = await fetch(`${apiUrl}/lineDetect`, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`lineDetect failed: ${response.status}`);
      }

      const data = await response.json();
      // 期待: data.image (base64 PNG), data.line_segments (線分データ), data.ellipses
      console.log('Response data keys:', Object.keys(data));
      console.log('Image length:', data.image?.length);
      console.log('Line segments count:', data.line_segments?.length);
      
      if (data.image) {
        const imageUrl = `data:image/png;base64,${data.image}`;
        console.log('Setting resultImage, first 50 chars:', imageUrl.substring(0, 50));
        setResultImage(imageUrl);
      }
      setResult(data);
      console.log('Line segments data:', data.line_segments);
      console.log('Full response:', data);

    } catch (err) {
      console.error('Failed to run line detection:', err);
      alert('線分検出に失敗しました: ' + (err.message || err));
    } finally {
      setIsRunning(false);
    }
  };

  return (
    <div className="page">
      <Hamburger />
      <h1 className="heading-hero mb-2">線分抽出</h1>
      <p className="text-subtitle mb-6">楕円を抽出したので、線分を抽出します。</p>
      {receivedState && (
        <div className="card-wide">
          <div className="form-group">
            <div>
              <h2 className="heading-lg">受け取ったデータ</h2>
              <p className="text-subtitle">選択数: {(() => {
                const all = receivedState.ellipses || {};
                return Object.entries(all).filter(([, v]) => Number(v.isChecked || 0) === 1).length;
              })()}</p>
            </div>
            {receivedState.imageUrl && (
              <img src={receivedState.imageUrl} alt="selected" className="w-full max-w-md rounded shadow" />
            )}
            <div className="row-center">
              <button
                onClick={handleStart}
                className="btn btn--secondary"
                disabled={isRunning}
              >
                {isRunning ? '解析中...' : '線分検出を開始'}
              </button>
              <button
                onClick={() => navigate(-1)}
                className="btn btn--gray"
              >
                戻る
              </button>
            </div>
            {result && (
              <div className="form-group">
                <div>
                  <h3 className="heading-lg">解析結果</h3>
                  {resultImage ? (
                    <>
                      <p className="text-subtitle">画像サイズ: {resultImage.length} bytes</p>
                      <img src={resultImage} alt="result" className="w-full max-w-md rounded shadow" />
                    </>
                  ) : (
                    <p className="text-error">画像が見つかりません</p>
                  )}
                </div>
                {result.line_segments && (
                  <p className="text-subtitle">検出線分数: {result.line_segments.length}</p>
                )}
                <details>
                  <summary className="cursor-pointer heading-lg">詳細データ（クリックで展開）</summary>
                  <div className="overflow-x-auto max-h-96 bg-white rounded mt-2">
                    <table className="text-xs border-collapse border border-gray-300 w-full">
                      <tbody>
                        {Object.entries(result).map(([key, value]) => (
                          <tr key={key} className="hover:bg-gray-50">
                            <td className="border border-gray-300 px-3 py-2 font-semibold bg-gray-50 w-1/4">{key}</td>
                            <td className="border border-gray-300 px-3 py-2">
                              {typeof value === 'object' ? (
                                <pre className="text-xs overflow-auto max-h-24 bg-gray-100 p-2 rounded">{JSON.stringify(value, null, 2)}</pre>
                              ) : (
                                String(value)
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </details>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default LineDetection;